import { forwardRef, ResponsiveValue, Text as ChakraText, TextProps as ChakraTextProps } from '@chakra-ui/react';
import { TextSizes } from '../../types/bitkit';

export interface TextProps extends ChakraTextProps {
  hasEllipsis?: boolean;
  size?: ResponsiveValue<TextSizes>;
}

/**
 * `Text` component is the used to render text and paragraphs within an interface. It renders a `<p>` tag by default.
 */
const Text = forwardRef<TextProps, 'p'>((props, ref) => {
  const { hasEllipsis, ...rest } = props;
  const properties: ChakraTextProps = { ...rest };

  if (hasEllipsis) {
    if (!properties.maxWidth) {
      properties.maxWidth = '100%';
    }
    properties.textOverflow = 'ellipsis';
    properties.whiteSpace = 'nowrap';
    properties.overflow = 'hidden';
  }
  return <ChakraText as="p" {...properties} ref={ref} />;
});

export default Text;
